import GuaranteedAprExplanation from './components/GuaranteedAprExplanation'

const ContentGuaranteedApr = () => {
    return <GuaranteedAprExplanation />
}

export default ContentGuaranteedApr
